import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { CSVLink } from "react-csv";
import { Dropdown } from "react-bootstrap";
import { withRouter } from "../../../App";
import { connect, useDispatch } from "react-redux";
import { getCandidatesJobs } from "../../../store/selectors/Candidates/CandidatesList";
import { getCandidatesJob as getCandidatesJobAction } from "../../../store/actions/Candidates/candidateActions";
import { IMAGES } from "../../constant/theme";
import { dateFormat } from "../../../utils/date";
import swal from "sweetalert";
import { toast } from "react-toastify";
import { del } from "../../../services/api";
import { getLoggenInToken } from "../../../store/selectors/AuthSelectors";
import EditCandidate from "./EditCandidate";
import Status from "../Common/Status";
import CandidateDetails from "./CandidateDetails";
import { days, weekdays } from "../../constant/weekday";

const headersTitle = [
  { label: "First Name", key: "firstName" },
  { label: "Last Name", key: "lastName" },
  { label: "Email", key: "email" },
  { label: "Office", key: "office" },
  { label: "Registration Date", key: "regDate" },
  { label: "Status", key: "status" },
];

const CandidateJobs = ({ title, candidateJobs,token }) => {
  const editCandidateRef = useRef();
  const candidateDetailsRef = useRef();
  const dispatch = useDispatch();
  const [selectedCandidate, setSelectedCandidate] = useState({});
  const [currentPage, setCurrentPage] = useState(1);
  const recordsPage = 10;
  const lastIndex = currentPage * recordsPage;
  const firstIndex = lastIndex - recordsPage;
  const records = candidateJobs?.slice(firstIndex, lastIndex);
  const npage = Math.ceil(candidateJobs?.length / recordsPage);
  const number = [...Array(npage + 1).keys()].slice(1);
  function prePage() {
    if (currentPage !== 1) {
      setCurrentPage(currentPage - 1);
    }
  }
  function changeCPage(id) {
    setCurrentPage(id);
  }
  function nextPage() {
    if (currentPage !== npage) {
      setCurrentPage(currentPage + 1);
    }
  }
  const [checked, setChecked] = useState([]);
  const [unchecked, setUnChecked] = useState(true);
  useEffect(() => {
    setChecked(
      candidateJobs?.slice(firstIndex, lastIndex).map((candidate) => ({
        ...candidate,
        inputchecked: false,
      }))
    );
  }, [candidateJobs, currentPage]);
  useEffect(() => {
    setCurrentPage(1); // Reset to first page on data update
  }, [candidateJobs]);
  const handleChecked = (id) => {
    setChecked((prevChecked) =>
      prevChecked.map((candidate) =>
        candidate._id === id
          ? { ...candidate, inputchecked: !candidate.inputchecked }
          : candidate
      )
    );
  };
  const handleCheckedAll = (value) => {
    let temp = checked.map((data) => {
      return { ...data, inputchecked: value };
    });
    setChecked(temp);
    setUnChecked(!unchecked);
  };
  return (
    <>
      <div className="card">
        <div className="card-body p-0">
          <div className="table-responsive active-projects style-1 ItemsCheckboxSec shorting">
            <div className="tbl-caption">
              <h4 className="heading mb-0">{title}</h4>
              <div>
                <CSVLink
                  // headers={headersTitle}
                  data={candidateJobs}
                  filename={"candidateJobs.csv"}
                  className="btn btn-primary light btn-sm me-2"
                >
                  <i className="fa-solid fa-file-excel" /> Export Report
                </CSVLink>
              </div>
            </div>
            <div id="user-tbl_wrapper" className="dataTables_wrapper no-footer">
              <table
                id="projects-tbl"
                className="table ItemsCheckboxSec dataTable no-footer mb-2 mb-sm-0"
              >
                <thead>
                  <tr>
                    <th className="sorting_asc_11">
                      <div className="form-check custom-checkbox ms-0">
                        <input
                          type="checkbox"
                          className="form-check-input checkAllInput"
                          required=""
                          onClick={() => handleCheckedAll(unchecked)}
                        />
                        <label
                          className="form-check-label"
                          htmlFor="checkAll"
                        ></label>
                      </div>
                    </th>
                    <th>Company</th>
                    <th>Job Title</th>
                    <th>Duration</th>
                    {/* <th>Service</th> */}
                    {/* <th>Job Type</th> */}
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  {checked.map((item, index) => (
                    <tr key={index}>
                      <td className="sorting_20">
                        <div className="form-check11custom-checkbox">
                          <input
                            type="checkbox"
                            className="form-check-input"
                            id={`user-${item._id}`}
                            checked={item.inputchecked}
                            onChange={() => handleChecked(item._id)}
                          />
                          <label
                            className="form-check-label"
                            htmlFor={`user-${item._id}`}
                          ></label>
                        </div>
                      </td>
                      <td>
                        <div className="d-flex align-items-center">
                          {/* <img
                            src={IMAGES.contact6}
                            className="avatar rounded-circle"
                            alt=""
                          /> */}
                          <p className="mb-0 ms-2">{item.companyName}</p>
                        </div>
                      </td>
                      <td>{item.jobTitle}</td>
                      {/* <td>{item.latestAction}</td> */}
                      <td>{dateFormat(item.jobStartDate) +' to '+ dateFormat(item.jobEndDate)}</td>
                      {/* <td>{item.service}</td>
                      <td>{item.jobType}</td> */}
                    
                      <td>
                        {/* <Dropdown>
                          <Dropdown.Toggle
                            as="div"
                            className="btn-link i-false"
                          >
                            <svg
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M11 12C11 12.5523 11.4477 13 12 13C12.5523 13 13 12.5523 13 12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12Z"
                                stroke="#737B8B"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              ></path>
                              <path
                                d="M18 12C18 12.5523 18.4477 13 19 13C19.5523 13 20 12.5523 20 12C20 11.4477 19.5523 11 19 11C18.4477 11 18 11.4477 18 12Z"
                                stroke="#737B8B"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              ></path>
                              <path
                                d="M4 12C4 12.5523 4.44772 13 5 13C5.55228 13 6 12.5523 6 12C6 11.4477 5.55228 11 5 11C4.44772 11 4 11.4477 4 12Z"
                                stroke="#737B8B"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              ></path>
                            </svg>
                          </Dropdown.Toggle>
                          <Dropdown.Menu
                            className="dropdown-menu-right"
                            align="end"
                          >
                            <Dropdown.Item
                              onClick={(e) => {
                                e.preventDefault();
                                setSelectedCandidate(item);
                                editCandidateRef.current.showEmployeModal();
                              }}
                            >
                              Edit Candidate
                            </Dropdown.Item>
                            <Dropdown.Item
                              onClick={(e) => {
                                e.preventDefault();
                                setSelectedCandidate(item);
                                candidateDetailsRef.current.showEmployeModal();
                              }}
                            >
                              Candidate Details
                            </Dropdown.Item>
                            <Dropdown.Item
                              onClick={(e) => {
                                e.preventDefault();
                                swal({
                                  title: "Are you sure?",
                                  text: "Once deleted, you will not be able to recover this candidate!",
                                  icon: "warning",
                                  buttons: true,
                                  confirmButtonText: "Delete",
                                  dangerMode: true,
                                }).then(async (willDelete) => {
                                  if (willDelete) {
                                    await del(
                                      "/api/candidate/" + item?._id,
                                      token
                                    );
                                    toast.success(
                                      "Candidate deletes successully."
                                    );
                                    dispatch(getCandidatesJobAction(token));
                                  } else {
                                    // swal("Your imaginary file is safe!");
                                  }
                                });
                              }}
                            >
                              Delete
                            </Dropdown.Item>
                          </Dropdown.Menu>
                        </Dropdown> */}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
              <div className="d-sm-flex text-center justify-content-between align-items-center">
                <div className="dataTables_info">
                  Showing {lastIndex - recordsPage + 1} to {lastIndex} of{" "}
                  {candidateJobs.length} entries
                </div>
                <div
                  className="dataTables_paginate paging_simple_numbers justify-content-center"
                  id="example2_paginate"
                >
                  <Link
                    className="paginate_button previous disabled"
                    to="#"
                    onClick={prePage}
                  >
                    <i className="fa-solid fa-angle-left" />
                  </Link>
                  <span>
                    {number.map((n, i) => (
                      <Link
                        className={`paginate_button ${
                          currentPage === n ? "current" : ""
                        } `}
                        key={i}
                        onClick={() => changeCPage(n)}
                      >
                        {n}
                      </Link>
                    ))}
                  </span>
                  <Link
                    className="paginate_button next"
                    to="#"
                    onClick={nextPage}
                  >
                    <i className="fa-solid fa-angle-right" />
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <EditCandidate
        ref={editCandidateRef}
        candidate={selectedCandidate}
        Title="Edit Candidate"
        token={token}
      />
      <CandidateDetails
        ref={candidateDetailsRef}
        candidate={selectedCandidate}
        Title="Candidate Details"
        token={token}
      />
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    candidateJobs: getCandidatesJobs(state),
    token: getLoggenInToken(state),
  };
};

export default withRouter(connect(mapStateToProps)(CandidateJobs));
